import * as React from "react";
import styled from "styled-components";
import { VerticalSpacer } from "../Spacers";
import { theme } from "../../../theme";

interface Props {
  onClick?: (props?: any) => void;
  disabled?: boolean;
  title: string;
  color?: string;
  icon?: React.ReactNode;
  size?: "small" | "medium" | "large";
}

const ButtonContainer = styled.button<{
  size: "small" | "medium" | "large";
  disabled?: boolean;
}>`
  background-color: ${(props) =>
    props.disabled ? theme.colors.disabled : theme.colors.grey05};
  border-radius: 4px;
  padding: 12px 16px 12px 16px;
  color: ${(props) => (props.disabled ? "white" : theme.colors.text)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  height: ${(props) =>
    props.size === "small" ? "24px" : props.size === "large" ? "44px" : "36px"};
  font-size: ${(props) => (props.size !== "small" ? "16px" : "14px")};

  &:hover {
    box-shadow: ${theme.shadow.cardShadow};
  }

  &:active {
    box-shadow: none;
    background-color: ${theme.colors.grey10};
  }
`;

const DefaultButton: React.FC<Props> = ({
  onClick,
  disabled,
  title,
  icon,
  size = "medium",
}) => {
  return (
    <ButtonContainer onClick={onClick} disabled={disabled} size={size}>
      {icon && (
        <>
          {icon} <VerticalSpacer spacing={0.5} />
        </>
      )}
      {title}
    </ButtonContainer>
  );
};

export default DefaultButton;
